
//export var API_HOST = "https://npgt3g5s71.execute-api.us-east-2.amazonaws.com/dev/v1/sites/details/" // dev Environment
export var API_HOST = "https://6fuxwiw3ch.execute-api.us-east-2.amazonaws.com/test/v1/sites/details/" // test Environment
//export var API_HOST = "https://tad7h5tbm5.execute-api.us-east-2.amazonaws.com/qa/v1/sites/details/" // qa Environment
//export var API_HOST = "https://jxtjrmakd2.execute-api.us-east-2.amazonaws.com/prod/v1/sites/details/" // prod Environment
